import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import {
    faSearch,
    faCircleArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Table from "../../components/Table";
import Section from "../../components/Section";
import apiClient from "../../axios";

import Loader from "../../components/Loader";

const WhatsAppUsersList = ({ handleLogout }) => {
    const [data, setData] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 10;
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const navigate = useNavigate();

    const fetchAllData = useCallback(async (page = 1) => {
        try {
            setLoading(true);
            const response = await apiClient.get(`/whatsappDetails/plans?page=${page}`);
            if (Array.isArray(response.data.results)) {
                setData(response.data.results);
                setTotalItems(response.data.total);
            } else {
                setData([response.data.results]);
                setTotalItems(1);
            }
        } catch (error) {
            setIsErrorVisible(true);
            if (error.response && error.response.status === 401) {
                setIsInfoVisible(true);
            }
        } finally {
            setIsSuccessVisible(true);
            setLoading(false);
        }
    }, [])

    const handleSearch = useCallback(
        async (page = 1) => {
            try {
                // Construir la URL con los query params
                const params = new URLSearchParams();
                if (searchTerm) params.append("search", searchTerm);

                const response = await apiClient.get(
                    `/whatsappDetails/plans?${params.toString()}`
                );

                if (Array.isArray(response.data.results)) {
                    setData(response.data.results); // Si es un array, lo dejamos tal cual
                } else {
                    setData([response.data.results]); // Si es un objeto, lo encapsulamos en un array
                }
                setTotalItems(response.data.total);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    setIsInfoVisible(true);
                }
            }
        },
        [searchTerm]
    );
    const handleFresh = async (code) => {
        //handleSearch(1);
        setCurrentPage(1);
        setSearchTerm(searchInput.trim());
    };

    const onRefreshThis = () => {
        setSearchTerm('');
        fetchAllData(1);
    };

    useEffect(() => {
        if (searchTerm) {
            handleSearch(currentPage);
        } else {
            fetchAllData(currentPage);
        }

    }, [fetchAllData, handleSearch, searchTerm, currentPage]);


    const handleClick = () => {
        navigate(-1);
    };

    const columns = [
        { title: "Id", key: "id" },
        { title: "RUC", key: "ruc" },
        { title: "Nombre", key: "user" },
        { title: "Email", key: "email" },
        { title: "NRO. Celular", key: "phone" },
    ];

    const renderRow = (item, index) => {

        return (
            <>
                <td>{item.id}</td>
                <td>{item.dni}</td>
                <td>{item.name} {item.lastName}</td>
                <td>{item.email}</td>
                <td>+{item.phoneNumber}</td>
            </>
        );
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Usuarios de Whatsapp" />
            <div className="home-content">
                <Section>
                    <div className="button-return-container">
                        <div className="contener-return">
                            <FontAwesomeIcon
                                className="basic-shortcut-icon"
                                style={{ cursor: "pointer" }}
                                icon={faCircleArrowLeft}
                                onClick={handleClick}
                            />
                        </div>
                        <div className="filter-form">
                            <div className="basic-info-form-group">
                                <input
                                    type="text"
                                    id="customer"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    placeholder="Usuario de WhatsApp"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleFresh();
                                        }
                                    }}
                                />
                            </div>
                            <button className="basic-custom-button" onClick={handleFresh}>
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    className="basic-shortcut-icon"
                                />
                                Buscar
                            </button>
                        </div>
                    </div>
                </Section>
                <Table
                    title={`Lista de Usuarios de WhatsApp`}
                    rows={data}
                    columns={columns}
                    icon={faWhatsapp}
                    renderRow={renderRow}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    onPageChange={setCurrentPage}
                    onRefresh={onRefreshThis}
                    loading={loading}
                    flagPagination={true}
                />
                {loading && <Loader />}
                <SuccessNotification
                    message={"Se ha cargado correctamente"}
                    isVisible={isSuccessVisible}
                    onClose={() => setIsSuccessVisible(false)}
                />
                <ErrorNotification
                    message="Ups! Ocurrio un Problema"
                    isVisible={isErrorVisible}
                    onClose={() => setIsErrorVisible(false)}
                />
                <LoginNotification
                    message="Vuele a iniciar sesión"
                    isVisible={isInfoVisible}
                    onClose={() => setIsInfoVisible(false)}
                    onLogout={handleLogout}
                />
                
            </div>
        </div>
    );
};

export default WhatsAppUsersList;
